import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const fetchServiceRequests = async ({ pageParam = 1, search, statusFilter, serviceTypeFilter, sortBy, limit = 16 }) => {
  const res = await apiClient.post("/api/v9/serviceRequest/getAllServiceRequestVision", {
    page: pageParam,
    limit,
    search,
    statusFilter,
    serviceTypeFilter,
    sortBy,
  });

  return res?.data;
};

export const useServiceRequestsInfinite = ({ search, statusFilter, serviceTypeFilter, sortBy, limit = 16 }) => {
  const isSearching = Boolean(search && search.trim());
  return useInfiniteQuery({
    queryKey: ["service-requests", search, statusFilter, serviceTypeFilter, sortBy, limit],

    queryFn: ({ pageParam }) =>
      fetchServiceRequests({
        pageParam,
        search,
        statusFilter,
        serviceTypeFilter,
        sortBy,
        limit,
      }),

    getNextPageParam: (lastPage) => {
      if (isSearching) return undefined;
      const { page, totalPages } = lastPage.pagination;
      return page < totalPages ? page + 1 : undefined;
    },
  });
};




//  All Details for Single Service Request

const fetchServiceRequestDetails = async (serviceRequestId) => {
  if (!serviceRequestId) return null;

  const res = await apiClient.post(
    "/api/v9/serviceRequest/getServiceRequestDetailsVision",
    { serviceRequestId }
  );

  return res.data?.data;
};


export const useServiceRequestDetails = (serviceRequestId) => {
  return useQuery({
    queryKey: ["service-request-details", serviceRequestId],
    queryFn: () => fetchServiceRequestDetails(serviceRequestId),
    enabled: !!serviceRequestId,
    staleTime: 5 * 60 * 1000,
  });
};



// Update Service Request Details

export const updateServiceRequest = async (payload) => {
  const res = await apiClient.post(
    "/api/v9/serviceRequest/updateServiceRequestVision",
    payload
  );

  return res.data;
};



// Update Button Status 

export const updateServiceRequestStatus = async ({ serviceRequestId, status }) => {
  const res = await apiClient.post(
    "/api/v9/serviceRequest/updateStatusVision",
    {
      serviceRequestId,
      status,
    }
  );
  return res.data;
};


// Upload binnys Image
export const uploadImageInServiceRequest = async ({ serviceRequestId, images }) => {
  const formData = new FormData();

  formData.append("serviceRequestId", serviceRequestId);

  // if multiple images
  images.forEach((file) => {
    formData.append("binnysImageUrls", file);
  });

  const res = await apiClient.post(
    "api/v9/serviceRequest/uploadBinnysImages",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};


// get Comment API 

const fetchAllServiceComment = async({queryKey}) =>{
  const [_key, serviceRequestId] = queryKey;
  
  if (!serviceRequestId) {
    throw new Error("Service Request ID is required");
  }
  
  const res = await apiClient.post("/api/v9/serviceRequest/getCommentsVision", {
    serviceRequestId: serviceRequestId
  });

  return res.data;
}

export const useFetchComment = ({serviceRequestId}) => {
  return useQuery({
    queryKey: ["serviceComment", serviceRequestId],
    queryFn: fetchAllServiceComment, // Function reference, not function call
    enabled: !!serviceRequestId, // Optional: Only run query when serviceRequestId exists
  });
}


// add Comment API

export const postServiceComment = async(formData) =>{
  const res = await apiClient.post("/api/v9/serviceRequest/addCommentVision",formData,{
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return res.data;
}

// export const usePostComment = () =>{
//   return useMutation({
//     mutationFn:postServiceComment
//   })
// }

const fetchAllClients = async ({ pageParam = 1, order, search, sortBy, limit = 20 }) => {
  const res = await apiClient.post("/api/v9/serviceRequest/getAllClientCompanys", {
    page: pageParam,
    search,
    limit,
    order,
    sortBy,
  });

  return res?.data;
};

export const useAllClientsinfinite = (params = {}) => {
  const { page, search, order, sortBy, limit = 20 } = params || {};
  
  const isSearching = Boolean(search && search.trim());
  
  return useInfiniteQuery({
    queryKey: ["allClients", page, search, order, sortBy, limit],

    queryFn: ({ pageParam }) =>
      fetchAllClients({
        pageParam,
        search,
        order,
        sortBy,
        limit,
      }),

    getNextPageParam: (lastPage) => {
      if (!lastPage || !lastPage.pagination || isSearching) {
        return undefined;
      }
      
      const { page, totalPages } = lastPage.pagination;
      return page < totalPages ? page + 1 : undefined;
    },
    
    initialPageParam: 1,
  });
};